module.exports = __webpack_public_path__ + "static/media/invoice_icon.4789b09f.svg";